type Status = 'met' | 'missed' | 'pending'

interface GoalStatusBadgeProps {
  status: Status
  size?: 'sm' | 'md'
}

const statusConfig: Record<Status, { label: string; bg: string; text: string }> = {
  met: { label: 'On Track', bg: 'bg-success-100', text: 'text-success-700' },
  missed: { label: 'Missed', bg: 'bg-danger-100', text: 'text-danger-700' },
  pending: { label: 'Pending', bg: 'bg-gray-100', text: 'text-gray-600' },
}

export function GoalStatusBadge({ status, size = 'md' }: GoalStatusBadgeProps) {
  const config = statusConfig[status]
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1'

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${config.bg} ${config.text} ${sizeClasses}`}>
      {config.label}
    </span>
  )
}

// Simple colored cell for table (mimics Bloom Growth style)
export function GoalStatusCell({ status }: { status: Status }) {
  const bgColors: Record<Status, string> = {
    met: 'bg-success-100',
    missed: 'bg-danger-100',
    pending: 'bg-gray-50',
  }
  return <div className={`w-full h-full ${bgColors[status]}`} />
}
